import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import type { AuthContext } from '../stores/auth';
import PageNotFound from '@/shared/components/error/PageNotFound';
import ErrorScreen from '@/shared/components/error/ErrorScreen';
import { Toaster } from '@/shared/components/ui/Sonner';

interface MyRouterContext {
  auth: {
    isAuthenticated: boolean;
    token: AuthContext['decodedToken'] | null;
  };
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <Outlet />
      <Toaster richColors position="top-center" offset={20} duration={5000} />
      <TanStackRouterDevtools position="bottom-right" initialIsOpen={false} />
    </>
  ),
  notFoundComponent: PageNotFound,
  errorComponent: ErrorScreen,
})